import React from "react";
import CodeExample from "../partials/content/CodeExample";
import { Table } from "react-bootstrap";
import { Bounce } from 'react-activity';
import { getStockStatus,getMyAccounts,getMaster,getStatusSummary,getAccountDetails,getSchedulesById,completeTask,getStatus,getWidgetDataByAccount,getMyProfile } from "../crud/auth.crud";
import {
  Portlet,
  PortletBody,
//  PortletHeader,
//  PortletHeaderToolbar
} from "../partials/content/Portlet";
 import { Link } from "react-router-dom";
//import GaugeChart from 'react-gauge-chart'
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';					
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import Alert from '@material-ui/lab/Alert'

import CircularProgress from '@material-ui/core/CircularProgress';

import { Bar,Line } from 'react-chartjs-2';

 const yearOptions = {
  legend: {
        display: false
    },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};


export default class StatusTiles extends React.Component {
  state = {
    mStatus:[],
    schedules:[],
    widgetData:[],
    summary:[],
    account:{},
    isReset:false,
    filter:false,
    isLoading:false,
    entity:[],
    accounts:[],
    businessEntity:'',
    selaccount:null,
    summaryOld:[],
    isSalesYearLoading:false,
    salesYear: null,

  }

 
  constructor(props)
{
	super(props);
	this.handleChangeEntity = this.handleChangeEntity.bind(this);
  this.handleChangeAccount = this.handleChangeAccount.bind(this);
}

  handleFilter(event)
	{

    if(this.state.selaccount!==null && this.state.selaccount!=="")
    {
      this.setState({isLoading:true})
      getStatusSummary(this.state.selaccount).then(response => response.data)
      .then((data) => {
        this.setState({ summary: data,isLoading:false });
        console.log("summary:::",data);
        //console.log(this.state.schedules);
      })
    }

  }


   handleReset(event)
  {
    this.setState({ summary: this.state.summaryOld, isReset:false,selaccount:"",businessEntity:""});
		 	
  }


  async componentDidMount()
  {

    let widgetData=[];
    widgetData.push({accountKey:"ACC00044",user:12,storage:1,userPercentage:40,storagePercentage:10});
     widgetData.push({accountKey:"ACC00045",user:10,storage:2,userPercentage:30,storagePercentage:20});
      widgetData.push({accountKey:"ACC00046",user:8,storage:3,userPercentage:28,storagePercentage:30});
       widgetData.push({accountKey:"ACC00047",user:20,storage:8,userPercentage:60,storagePercentage:80});
    this.setState({widgetData:widgetData,isSalesYearLoading:true});
    
    await getMaster('entity')
							.then((response)=>
								{
									//console.log('Master :',fieldMap.fieldName);
									//alert(fieldMap.fieldName);
									this.setState({entity:response.data});
								


								})

                await getMyAccounts().then((response)=>{
                  this.setState({accounts:response.data});
                })
     
    getStatusSummary().then(response => response.data)
    .then((data) => {
      this.setState({ summary: data,summaryOld:data });
      console.log("summary:::",data);
      //console.log(this.state.schedules);
     })
    getStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
      console.log("status:::",data);
     });

    getAccountDetails().then(response => response.data)
    .then((data) => {
      this.setState({ account: data })
      console.log("account:::",data);
     });
 
    getMyProfile().then(response => response.data)
    .then((data) => {
      //this.setState({ users: data })
      //console.log(this.state.users)
      /*
       getWidgetDataByAccount(data[0].accountKey).then(response => response.data)
    .then((data) => {
      if(data[0]!=null)
      {
      this.setState({ widgetData: data[0] })
      console.log("widgetData:::",data[0]);
      }
     });
     */ widgetData.filter(r=>r.accountKey == data[0].accountKey).map((d)=>(
        this.setState({ widget: d })

      )

        )
        //let widgetData = {users: 10, }
        

     })

      getStockStatus().then(response => response.data)
    .then((data) => {
      this.setState({ stockstatus: data });
      console.log("stockstatus:::",data);
      //console.log(this.state.schedules);
      if(data.length>1)
      {
       let salesyrdata = {
                 labels: [ 'Total Stock','Min Stock','Max Stock'],
                 datasets: [
                   {
                     //label: ['Min Stock', 'Total Stock','Max Stock'],
                     data: [data[0].total,data[1].minStocks,data[1].maxStocks],
                     backgroundColor: ["#75f71b","#f7611b","#f7f41b"],
                     fill:false,
                     borderWidth: 0,
                   }
                   
                   ],
                 };
     
     
                 this.setState({isSalesYearLoading:false,salesYear:salesyrdata});
                }
     })

      
    
  }
  handleChangeEntity(event)
  {
    //console.log(event);
    this.setState({businessEntity:event.target.value});
  }

  handleChangeAccount(event)
  {
    //console.log(event);
    this.setState({selaccount:event.target.value});
    
  }
  
  
  render() {
    return (
      <>

        <div className="row">
          <div className="col-xl-12">
              <CodeExample jsCode="true" beforeCodeTitle="Filter">
                <div className="kt-section" >
                  <Grid container spacing={3}>
                  
                    <Grid item xs={12} sm={6}>
                      <TextField  style={{'width':'100%'}} name="businessEntity" 
                          id="businessEntity"  label="Account Type"
                          onChange={this.handleChangeEntity}
                          value={this.state.businessEntity}
                            select>
                              
                          <MenuItem value="">Select</MenuItem>
                          { 
                          this.state.entity.length>0 && this.state.entity.map((ent) => (
                            
                            <MenuItem key={ent.businessEntity} value={ent.businessEntity}>{ent.businessEntity}</MenuItem>
                              
                          ))
                          }
                         
                      </TextField>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField  style={{'width':'100%'}} name="accountKey" 
                          id="accountKey"  label="Account"
                          onChange={this.handleChangeAccount}
                            select>
                         
                          { 
                          this.state.accounts.length>0 && this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).length>0 && this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).map((acc) => (
                            
                            <MenuItem key={acc.accountId} value={acc.accountId}>{acc.accountName}</MenuItem>
                              
                          ))
                          }
                          {
                            this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).length===0 &&
                              <MenuItem value="">None</MenuItem>
                          }
                      </TextField>

                    </Grid>
                  </Grid>
                </div>
            
            <div>
            <Button
          variant="outlined"
          color="primary"
          onClick={this.handleFilter.bind(this)}
          endIcon={<Icon>search</Icon>}
          style={{'padding':'10px','margin':'10px'}}
          >
          {
            this.state.isLoading==true&&<><Bounce /></>
          }
          {
            this.state.isLoading==false&&<>Apply Filter</>
          }
          </Button>
          
          <Button
          variant="outlined"
          color="primary"
          onClick={this.handleReset.bind(this)}
          endIcon={<Icon>backspace</Icon>}
          style={{'padding':'10px','margin':'10px'}}
          >
          {
            this.state.isReset==true&&<><Bounce /></>
          }
          {
            this.state.isReset==false&&<>Reset Filter</>
          }
          </Button>
          </div>

              </CodeExample>
          </div>
        <div className="col-xl-12">
          <div className="row">
           {this.state.mStatus.map((status,index) => (


            <div className="col-lg-3" key={"a"+index}>
            <Link to={{pathname:"/schedule", data: {statusKey:status.statusKey,accountId:this.state.selaccount}}}>
              <Portlet className="kt-portlet--border-bottom-brand" >
                <PortletBody fluid={true}>
                  
                    <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number" style={{'color':status.statusId}}> 
                        {this.state.summary.filter(s=> s.statusKey==status.statusKey).map((sum)=>(
                          sum.count
                          ))}
                        
                      </span>
                      <span className="kt-widget26__desc" style={{'color':status.statusId}}>{status.statusName}</span>
                    </div>
                    </div>
                  
                </PortletBody>
              </Portlet>
              </Link>
             </div>
            ))}
            
            {this.state.widget !=null &&
             <div className="col-lg-3">
              <Portlet className="kt-portlet--border-bottom-brand" >
                <PortletBody fluid={true}>
                  {/*<GaugeChart id="gauge-chart5"
                    nrOfLevels={this.state.widget.storage}
                    arcsLength={[0.5, 0.5, 0.5]}
                    colors={['#5BE12C', '#F5CD19', '#EA4228']}
                    percent={this.state.widget.storagePercentage}
                    arcPadding={0.01}
                    textColor={'black'}
                    formatTextValue={value=> 'Storage ' + value + '%'}
                  />*/}
                  
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <div className="kt-widget__progress">
                              <div className="kt-widget__text">
                                Storage
                              </div>
                              <div className="progress" style={{height: '5px',width: '100%'}}>
                                <div className="progress-bar kt-bg-success" role="progressbar" style={{width: Math.round(this.state.account.storageUtilized/1024/1024/1024,2)*100/ this.state.account.allocatedStorage+'%'}} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                              </div>
                              <div className="kt-widget26__number">
                                {this.state.account.storageUtilized == 0 && '0%'}
                                {this.state.account.storageUtilized != 0 && Math.round(this.state.account.storageUtilized/1024/1024/1024,2)*100/ this.state.account.allocatedStorage+'%'}
                                {'('+Math.round(this.state.account.storageUtilized/1024/1024/1024,2) +'/'+ this.state.account.allocatedStorage+')'}
                                
                              </div>
                            </div>
                    </div>
                  </div>
                
                </PortletBody>
              </Portlet>
             </div>
           }
           

             {this.state.widget !=null &&
             <div className="col-lg-3">
              <Portlet className="kt-portlet--border-bottom-brand" >
                <PortletBody fluid={true}>
                  {/*
                  <GaugeChart id="gauge-chart6"
                    nrOfLevels={this.state.widget.users}
                    arcsLength={[0.5, 0.5, 0.5]}
                    colors={['#5BE12C', '#F5CD19', '#EA4228']}
                    percent={this.state.widget.userPercentage}
                    arcPadding={0.01}
                    textColor={'black'}
                    formatTextValue={value=> 'Users ' + value + '%'}
                  />
                  */}
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      
                      <div className="kt-widget__progress">
                              <div className="kt-widget__text">
                                Users
                              </div>
                              <div className="progress" style={{height: '5px',width: '100%'}}>
                                <div className="progress-bar kt-bg-success" role="progressbar" style={{width: this.state.account.usersUtilized*100/ this.state.account.allocatedUsers+'%'}} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                              </div>
                              <div className="kt-widget26__number">
                                {this.state.account.usersUtilized*100/ this.state.account.allocatedUsers}% ({this.state.account.usersUtilized +'/'+ this.state.account.allocatedUsers })
                              </div>
                            </div>
                      
                    </div>
                  </div>
                  
                </PortletBody>
              </Portlet>
             </div>
           }
             
          </div>
        </div>
        <div className = "col-xl-12">
          <div className="row">
          {<div className="col-lg-6">
                       
                         <div className="kt-portlet kt-portlet--height-fluid">
                          <div className="kt-portlet__head">
                            <div className="kt-portlet__head-label">
                              <h3 className="kt-portlet__head-title">Live Stock Details</h3>
                            </div>
                           
                          </div>
                          <div className="kt-portlet__body">
                            {this.state.salesYear!==null &&
                              <Bar ref={this.chartReference}  data={this.state.salesYear} options={yearOptions} />
                            }
                            {this.state.isSalesYearLoading &&
                                    <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                                        <Alert severity="info" icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Loading...</Alert>      
                                    </div>
                              }
                          </div>
                        </div>
                        
                        
                      </div>}
                </div>     
        </div>
        
      </div>
       
      </>
    );
  }
}
